/*
  Magic T shared popups.
  Content lives in the page as <template data-mt-pop="ID" data-mt-pop-type="TYPE">, rendered by Liquid.
  Any element with data-mt-pop-open="ID" opens it. Optional data-mt-pop-hint="Label" adds a small link under it.
  Used by: snippets/mt-shipping-bar.liquid, snippets/mt-edition-counter.liquid, sections/bundle-products.liquid
  Clarity: fires event "popup_<type>" and sets tag "popup" to the ID on every open.
*/
(function () {
  if (window.MTPopup) return;

  var CSS = [
    '[data-mt-pop-open]{cursor:pointer;-webkit-tap-highlight-color:transparent}',
    '.bp-card__link[data-mt-pop-open]{height:100%}',
    '.mt-pop-hint{display:inline-flex;align-items:center;gap:5px;margin-top:8px;font-size:12px;font-weight:600;line-height:1.3;color:#2f4fb5;text-decoration:underline;text-underline-offset:2px;cursor:pointer}',
    '.mt-pop-hint svg{width:14px;height:14px;flex:none}',
    '.mt-trust+.mt-pop-hint{margin:-6px 0 12px 2px}',
    '.mt-pop-overlay{position:fixed;inset:0;z-index:2147483000;background:rgba(20,20,20,.45);display:flex;align-items:center;justify-content:center;padding:16px;opacity:0;transition:opacity .2s ease}',
    '.mt-pop-overlay.is-open{opacity:1}',
    '.mt-pop{position:relative;width:100%;max-width:440px;max-height:85vh;overflow-y:auto;overscroll-behavior:contain;background:#fff;color:#1a1a1a;border-radius:14px;padding:24px 22px 20px;box-shadow:0 12px 40px rgba(0,0,0,.18);transform:translateY(12px);transition:transform .2s ease;text-align:left}',
    '.mt-pop-overlay.is-open .mt-pop{transform:none}',
    '.mt-pop h2,.mt-pop h3{margin:0 40px 12px 0;font-size:19px;line-height:1.3;font-weight:600;letter-spacing:0;text-transform:none}',
    '.mt-pop h4{margin:16px 0 6px;font-size:13px;line-height:1.3;font-weight:700;letter-spacing:.04em;text-transform:uppercase;color:#6a6a6a}',
    '.mt-pop p{margin:0 0 10px;font-size:14.5px;line-height:1.55}',
    '.mt-pop ul{margin:0 0 12px;padding-left:18px;list-style:disc}',
    '.mt-pop li{margin:0 0 7px;font-size:14.5px;line-height:1.5;list-style:inherit}',
    '.mt-pop em{font-style:normal;font-size:13px;color:#6a6a6a}',
    '.mt-pop a{color:#2f4fb5;text-decoration:underline;text-underline-offset:2px}',
    '.mt-pop .mt-pop-muted{font-size:13px;color:#6a6a6a}',
    '.mt-pop .mt-pop-section{border-top:1px solid #ebe8e2;padding-top:14px;margin-top:14px}',
    '.mt-pop .mt-pop-section:first-of-type{border-top:0;padding-top:0;margin-top:0}',
    '.mt-pop-close{position:absolute;top:12px;right:12px;z-index:2;width:36px;height:36px;border:0;border-radius:50%;background:#f4f3f0;color:#1a1a1a;font-size:22px;line-height:36px;text-align:center;cursor:pointer;padding:0}',
    '.mt-pop-ok{display:block;width:100%;margin-top:8px;padding:12px;border:0;border-radius:8px;background:#1a1a1a;color:#fff;font-size:15px;font-weight:600;cursor:pointer}',
    '.mt-pop--quickview{padding:0 0 20px}',
    '.mt-pop--quickview .mt-qv__img{display:block;width:100%!important;max-width:100%!important;height:260px!important;max-height:none!important;margin:0!important;object-fit:cover;background:#f5f3ef;border-radius:14px 14px 0 0}',
    '.mt-pop--quickview .mt-qv__body{padding:18px 22px 0}',
    '.mt-pop--quickview .mt-pop-ok{width:calc(100% - 44px);margin:12px 22px 0}',
    '.mt-qv__meta{display:flex;flex-wrap:wrap;gap:4px 12px;margin:-6px 0 12px;font-size:13px;color:#6a6a6a}',
    '.mt-qv__stars{color:#f5a623;letter-spacing:1px}',
    '.mt-qv__link{display:inline-block;margin-top:4px;font-size:14px;font-weight:600}',
    '@media (max-width:767px){',
    '.mt-pop-overlay{align-items:flex-end;padding:0}',
    '.mt-pop{max-width:none;max-height:88vh;border-radius:16px 16px 0 0;padding-bottom:calc(20px + env(safe-area-inset-bottom));transform:translateY(40px)}',
    '.mt-pop--quickview{padding-bottom:calc(20px + env(safe-area-inset-bottom))}',
    '.mt-pop--quickview .mt-qv__img{border-radius:16px 16px 0 0;height:210px!important}',
    '}'
  ].join('');

  var st = document.createElement('style');
  st.setAttribute('data-mt-popup', '');
  st.textContent = CSS;
  document.head.appendChild(st);

  var ICON = '<svg viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="7" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M8 7v4.5M8 4.6v.1" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';
  var current = null;

  function track(id, type) {
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', 'popup_' + (type || 'info'));
        window.clarity('set', 'popup', id);
      }
    } catch (e) {}
  }

  function open(id, opener) {
    var tpl = document.querySelector('template[data-mt-pop="' + id + '"]');
    if (!tpl) return false;
    if (current) current.close(true);
    var type = tpl.getAttribute('data-mt-pop-type') || 'info';
    var lastFocus = opener || document.activeElement;

    var overlay = document.createElement('div');
    overlay.className = 'mt-pop-overlay';
    var box = document.createElement('div');
    box.className = 'mt-pop mt-pop--' + type;
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('tabindex', '-1');
    box.innerHTML = '<button type="button" class="mt-pop-close" aria-label="Close">&times;</button>';
    box.appendChild(tpl.content.cloneNode(true));
    var ok = document.createElement('button');
    ok.type = 'button';
    ok.className = 'mt-pop-ok';
    ok.textContent = tpl.getAttribute('data-mt-pop-ok') || 'Got it';
    box.appendChild(ok);
    overlay.appendChild(box);

    var heading = box.querySelector('h2, h3');
    if (heading) {
      heading.id = heading.id || 'mt-pop-title-' + id;
      box.setAttribute('aria-labelledby', heading.id);
    }

    function onKey(e) { if (e.key === 'Escape') close(); }
    function close(instant) {
      document.removeEventListener('keydown', onKey);
      document.documentElement.style.overflow = '';
      current = null;
      if (instant) { overlay.remove(); return; }
      overlay.classList.remove('is-open');
      setTimeout(function () { overlay.remove(); }, 200);
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    }

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.closest('.mt-pop-close, .mt-pop-ok')) close();
    });
    document.addEventListener('keydown', onKey);
    document.body.appendChild(overlay);
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      overlay.classList.add('is-open');
      try { box.focus({ preventScroll: true }); } catch (e) { box.focus(); }
    });
    current = { close: close };
    track(id, type);
    return true;
  }

  function addHints(root) {
    (root || document).querySelectorAll('[data-mt-pop-hint]:not([data-mt-pop-hinted])').forEach(function (el) {
      el.setAttribute('data-mt-pop-hinted', '');
      var hint = document.createElement('span');
      hint.className = 'mt-pop-hint';
      hint.setAttribute('aria-hidden', 'true');
      hint.innerHTML = ICON + el.getAttribute('data-mt-pop-hint');
      var where = el.getAttribute('data-mt-pop-hint-where');
      if (where === 'after') {
        hint.setAttribute('data-mt-pop-open', el.getAttribute('data-mt-pop-open'));
        el.parentNode.insertBefore(hint, el.nextSibling);
      } else {
        (el.querySelector('.bp-card__body') || el).appendChild(hint);
      }
    });
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-mt-pop-open]');
    if (!el || e.target.closest('.mt-pop')) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey) return;
    if (open(el.getAttribute('data-mt-pop-open'), el)) e.preventDefault();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var el = e.target.closest && e.target.closest('[data-mt-pop-open]');
    if (!el || el.tagName === 'A' || el.tagName === 'BUTTON') return;
    if (open(el.getAttribute('data-mt-pop-open'), el)) e.preventDefault();
  });

  window.MTPopup = { open: open, refresh: addHints };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { addHints(); });
  else addHints();
  document.addEventListener('shopify:section:load', function (e) { addHints(e.target); });
})();
